export default {
  title: '事業者管理',
  companyInfo: '企業情報',
  emailConfig: 'メール設定',
  smsConfig: 'SMS設定',
  i18nManagement: '多言語管理',
  paymentAuthConfig: '支払い・認証設定',
  systemSettings: 'システム設定',
  roleManagement: '役割管理',
  accountManagement: 'アカウント管理',
  operationLog: '操作ログ',
  companyName: '会社名',
  companyNameReadonly: '企業情報',
  companyNameReadonlyTip: 'この言語環境での会社表示名を入力してください',
  companyLogo: '会社ロゴ',
  companyLogoTip:
    '画像形式（JPG、PNG）とサイズ（5MB以内）に制限があります。アップロード後にサムネイル表示、差し替え可能です',
  companyLocaleLabel: '会社情報',
  companyEmail: '会社メールアドレス',
  companyEmailPlaceholder: '会社メールアドレスを入力してください',
  companyPhone: '会社電話番号',
  companyPhonePlaceholder: '電話番号を入力してください',
  companyAddress: '会社住所',
  companyAddressPlaceholder: '会社住所を入力してください',
  companyIntro: '会社概要',
  companyIntroPlaceholder: '会社概要を入力してください',
  save: '保存',
  saveSuccess: '保存しました',
  uploadSuccess: 'アップロード成功',
  uploadFail: 'アップロード失敗',
  logoFormatError: 'JPG、PNG形式のみ対応しています',
  logoSizeError: '画像サイズは5MB以内にしてください',
  locale_zh_TW: '繁体中国語',
  locale_zh_CN: '簡体中国語',
  locale_en_US: 'English',
  locale_ja_JP: '日本語',
};
